export const login = ( state, { model, token } ) => {
    if ( token ) {
        localStorage.setItem('token', token)
        state.token = token
    }

    state.user = model
    state.status = 'authenticated'
}

export const logout = ( state ) => {
    state.user = null
    state.token = null
    state.status = 'not-authenticated'
    
    localStorage.removeItem('token')
}
